import { render, staticRenderFns } from "./ScrollTopButton.vue?vue&type=template&id=67a5e6a9"
import script from "./ScrollTopButton.vue?vue&type=script&lang=js"
export * from "./ScrollTopButton.vue?vue&type=script&lang=js"
import style0 from "./ScrollTopButton.vue?vue&type=style&index=0&id=67a5e6a9&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports